import { Weather } from '../../types';
import { Services } from '../../types/DealerServices';
import { DealerState } from '../../types/DealerState';
import { IPitchStatusState } from '../../types/PitchStatus';
import { DealerActions, DealerActionType } from './DealerActions';

export const initialUserState: DealerState = {
  pitchStatus: [],
  selectedPitchStatus: {} as IPitchStatusState,
  dealerServices: [],
  dealerInfos: [],
  carFaxAdvantageStatus: false,
  marketConquestStatus: false,
  turnStatus: false,
  permissionGrantEnum: {},
  salesPersons: [],
  salespersonsIndexed: {},
  transUnionStatus: false,
  preownedStatus: false,
  weather: {} as Weather,
  featureToggle: {},
  userApiKey: '',
  hasCarFax: false,
  sendVideoStatus: false,
  isRooftop: false,
  isLoggedIntoCarFax: false,
  carFaxSnapshotkey: '',
  carFaxSnapshotkeyForReplacement: '',
  carFaxSnapshotkeyError: '',
  carFaxSnapshotkeyErrorForReplacement: '',
  storeServices: {} as Services,
  showPrivateIncentive: false,
  currentUrl: '',
  privateIncentiveCount: { dealerId: [], count: [] },
  eeqConquestPrivateIncentiveCount: { dealerId: [], count: [] },
  isLoadingDealer: true,
  isCrmPageAvailable: false,
  hasCpo: false,
};

export const dealerReducer = (
  state: DealerState = initialUserState,
  action: DealerActions,
): DealerState => {
  switch (action.type) {
    case DealerActionType.SET_SALES_PERSONS:
      return {
        ...state,
        salesPersons: action.payload,
      };

    case DealerActionType.SET_PITCH_STATUS:
      return {
        ...state,
        pitchStatus: action.payload,
      };

    case DealerActionType.SET_FEATURE_TOGGLE:
      return {
        ...state,
        featureToggle: action.payload,
      };

    case DealerActionType.SET_SELECTED_PITCH_STATUS:
      return {
        ...state,
        selectedPitchStatus: action.payload,
      };

    case DealerActionType.SET_DEALER_SERVICES:
      return {
        ...state,
        dealerServices: action.payload,
      };

    case DealerActionType.SET_STORE_SERVICES:
      return {
        ...state,
        storeServices: action.payload,
      };

    case DealerActionType.SET_DEALER_INFOS:
      return {
        ...state,
        dealerInfos: action.payload,
      };

    case DealerActionType.SET_CAR_FAX_ADVANTAGE_STATUS:
      return {
        ...state,
        carFaxAdvantageStatus: action.payload,
      };

    case DealerActionType.SET_CONQUEST_STATUS:
      return {
        ...state,
        marketConquestStatus: action.payload,
      };

    case DealerActionType.SET_TURN_STATUS:
      return {
        ...state,
        turnStatus: action.payload,
      };

    case DealerActionType.SET_TRANSUNION_STATUS:
      return {
        ...state,
        transUnionStatus: action.payload,
      };

    case DealerActionType.SET_SEND_VIDEO_STATUS:
      return {
        ...state,
        sendVideoStatus: action.payload,
      };

    case DealerActionType.SET_PREOWNED_STATUS:
      return {
        ...state,
        preownedStatus: action.payload,
      };

    case DealerActionType.SET_USER_API_KEY:
      return {
        ...state,
        userApiKey: action.payload,
      };

    case DealerActionType.SET_CAR_FAX_STATUS:
      return {
        ...state,
        hasCarFax: action.payload,
      };

    case DealerActionType.SET_ROOFTOP_STATUS:
      return {
        ...state,
        isRooftop: action.payload,
      };

    case DealerActionType.SET_IS_LOGGED_INTO_CARFAX:
      return {
        ...state,
        isLoggedIntoCarFax: action.payload,
      };

    case DealerActionType.SET_CARFAX_SNAPSHOTKEY:
      return {
        ...state,
        carFaxSnapshotkey: action.payload,
      };

    case DealerActionType.SET_CARFAX_SNAPSHOTKEY_ERROR:
      return {
        ...state,
        carFaxSnapshotkeyError: action.payload,
      };

    case DealerActionType.SET_CARFAX_SNAPSHOTKEY_FOR_REPLACEMENT:
      return {
        ...state,
        carFaxSnapshotkeyForReplacement: action.payload,
      };

    case DealerActionType.SET_CARFAX_SNAPSHOTKEY_ERROR_FOR_REPLACEMENT:
      return {
        ...state,
        carFaxSnapshotkeyErrorForReplacement: action.payload,
      };

    case DealerActionType.SET_SHOW_PRIVATEINCENTIVE_DIALOG:
      return {
        ...state,
        showPrivateIncentive: action.payload,
      };

    case DealerActionType.SET_CURRENT_PAGE_URL:
      return {
        ...state,
        currentUrl: action.payload,
      };

    case DealerActionType.SET_PRIVATE_INCENTIVE_COUNT:
      return {
        ...state,
        privateIncentiveCount: action.payload,
      };

    case DealerActionType.SET_EEQ_CONQUEST_PRIVATE_INCENTIVE_COUNT:
      return {
        ...state,
        eeqConquestPrivateIncentiveCount: action.payload,
      };

    case DealerActionType.SET_HAS_CPO:
      return {
        ...state,
        hasCpo: action.payload,
      };

    case DealerActionType.SET_IS_LOADING_DEALER:
      return {
        ...state,
        isLoadingDealer: action.payload,
      };

    case DealerActionType.SET_IS_CRM_PAGE_AVAILABLE:
      return {
        ...state,
        isCrmPageAvailable: action.payload,
      };

    default:
      return state;
  }
};
